module.exports = "\n<div v-el:item\n         class=\"vue-grid-item\"\n         :class=\"{ 'vue-resizable' : isResizable, 'resizing' : isResizing, 'vue-draggable-dragging' : isDragging, 'cssTransforms' : useCssTransforms }\"\n         :style=\"style\"\n    >\n    <slot></slot>\n    <!--<pre>\n        x: {{ x | json}}\n        y: {{ y | json}}\n        w: {{ w | json}}\n        h: {{ h | json}}\n    </pre>-->\n    <span v-if=\"isResizable\" v-el:handle class=\"vue-resizable-handle\"></span>\n</div>\n";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/GridItem.vue
 ** module id = 48
 ** module chunks = 0
 **/